const subscription = {
    limit_exceeded: 'คุณได้ถึงขีดจำกัดของแผนการสมัครสมาชิกของคุณแล้ว',
    get_plan_failed: 'ไม่สามารถดึงข้อมูลแผนการสมัครสมาชิกสำหรับผู้เช่าได้',
    tenant_suspended: 'ผู้เช่าถูกระงับ กรุณาติดต่อผู้ดูแลระบบของคุณ',
};
export default Object.freeze(subscription);
